
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/objects",
      function () {
        return require("private-next-pages/objects/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/objects"])
      });
    }
  